var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_logo_text"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":[_vm.faType, _vm.faName],"size":_vm.size}}),_c('span',{class:_vm.size},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }